import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Artist = /*#__PURE__*/function () {
  function Artist(context) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Artist);

    this.context = context;
    this.headers = headers;
  } // Creates a new Artist


  _createClass(Artist, [{
    key: "post",
    value: function post(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artist/item', params);
    }
  }]);

  return Artist;
}();

export default Artist;